import {Component, OnInit} from '@angular/core';
import {PublisherStatsService} from '../../shared/services/publishers-stats.service';
import {WidgetType} from '../../../shared/domain/widget-type.model';
import {KeyLabel} from '../../../shared/domain/key-label.model';
import {DevicePlacementLabels} from '../../../shared/domain/device-placement.model';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import {WidgetTypePreviewDialogComponent} from './widget-type-preview-dialog.component';
import {SnackBarService} from '../../../shared/services/snackbar.service';

@Component({
  selector: 'cm-products',
  templateUrl: './products.component.html',
  styleUrls: ['./products.component.scss']
})
export class ProductsComponent implements OnInit {

  public mostPopularSelected = false;
  public widgetTypes: WidgetType[] = [];
  public availablePlatforms: KeyLabel[] = [];
  public availableSizes: KeyLabel[] = [];
  private allWidgetTypes: WidgetType[] = [];
  private selectedPlatform: string;
  private selectedSize: string;
  private availableWidgets: WidgetType[];
  public selectedWidget: WidgetType;
  public isDataAvailable = false;
  public showLoader = false;

  constructor(private publishersService: PublisherStatsService,
              private snackBarService: SnackBarService,
              private dialog: MatDialog) {
  }

  ngOnInit(): void {
    this.showLoader = true;
    this.publishersService.listWidgetTypes().subscribe(
      next => {
        this.isDataAvailable = true;
        this.showLoader = false;
        this.allWidgetTypes = next;
        this.allWidgetTypes.forEach(type => {
          type._size = type.responsive ? 'responsive' : `${type.width}x${type.height}`;

          type._owned = type.publisherDomains && type.publisherDomains.length > 0;

          type.demoUrl = type.demoUrl || `https://dummyimage.com/${type.width || '300'}x${type.height || '250'}/d1d1d1/636363&text=${type.width || '300'}x${type.height || '250'}`;
          type.demoImageUrl = type.demoImageUrl || `https://dummyimage.com/${type.width || '300'}x${type.height || '250'}/d1d1d1/636363&text=${type.width || '300'}x${type.height || '250'}`;
        });

        this.allWidgetTypes.sort((a, b) => {
          if (a.responsive) {
            return 1;
          }
          if (a._size < b._size) {
            return -1;
          }
          if (a._size > b._size) {
            return 1;
          }
          return 0;
        });
        this.resetAvailableWidgetTypes();
      },
      error => {
        this.showLoader = false;
        this.snackBarService.error('Products unavailable at the moment, please try later');
      }
    );
  }

  public selectWidget(widget: WidgetType) {
    this.selectedWidget = widget;
  }

  public openDemoSite(widget: WidgetType) {

    // ngDialog.open(
    //   {
    //     plain: true,
    //     template: `
    //         <widget-type-live-demo-site-modal
    //         widget-type="ngDialogData.widgetType"
    //         close-this-dialog="closeThisDialog()">
    //         </widget-type-live-demo-site-modal>
    //     `,
    //     preserveFocus: false,
    //     data: {
    //       widgetType: widgetType,
    //     }
    //   });

  }

  public openPreviewModal(widgetType: WidgetType) {
    this.dialog.open(WidgetTypePreviewDialogComponent, <MatDialogConfig>{
      data: {
        widgetType: widgetType
      },
      panelClass: 'width-auto',
      width: `${widgetType.width + 200}px`
    });
  }

  public showMostPopular() {
    this.mostPopularSelected = true;
    this.resetAvailableWidgetTypes();
  }

  public showAllProducts() {
    this.mostPopularSelected = false;
    this.resetAvailableWidgetTypes();
  }

  private resetAvailableWidgetTypes() {
    this.widgetTypes = this.allWidgetTypes.filter(w => !this.mostPopularSelected || w.mostPopular);
    this.availablePlatforms = this.widgetTypes.reduce((seed, current) => {
      if (current.devicePlacements) {
        current.devicePlacements.split(',').forEach(placement => {
          if (!seed.find(s => s.key === placement)) {
            seed.push({
              key: placement,
              label: DevicePlacementLabels[placement]
            });
          }
        });
      }
      return seed;
    }, []);
    if (this.availablePlatforms.length) {
      this.onSelectedPlatform(this.availablePlatforms[0]);
    }
  }

  public onSelectedPlatformIndex(index: number) {
    this.onSelectedPlatform(this.availablePlatforms[index]);
  }

  private onSelectedPlatform(platform: KeyLabel) {
    this.selectedPlatform = platform.key;

    const uniqueSizesForPlatform = Array.from(new Set(this.widgetTypes.filter(this.containsPlatform.bind(this)).map(type => type._size)));
    this.availableSizes = uniqueSizesForPlatform
      .map(size => ({
        key: size,
        label: size === 'responsive' ? 'Responsive' : size
      }));

    this.onSelectedSize(this.availableSizes[0]);
  }

  private onSelectedSize(size: KeyLabel) {
    this.selectedSize = size.key;
    this.availableWidgets = this.widgetTypes.filter(this.containsPlatform.bind(this)).filter(this.containsSize.bind(this));
    this.availableWidgets.sort((a, b) => {
      if (a.mostPopular && !b.mostPopular) {
        return -1;
      } else if (!a.mostPopular && b.mostPopular) {
        return 1;
      } else {
        if (a.content > b.content) {
          return 1;
        }
        if (a.content < b.content) {
          return -1;
        }
      }
      return 0;
    });
  }

  private containsPlatform(widgetType) {
    return widgetType.devicePlacements ? widgetType.devicePlacements.split(',').includes(this.selectedPlatform) : false;
  }

  private containsSize(widgetType) {
    return widgetType._size === this.selectedSize;
  }

}
